module.exports = __webpack_public_path__ + "img/poster-zoom-rooms.24c330f6.png";